import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Constructions.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import Figure from '../Figure';
const Constructions = (props) => {
  const path = useContext(PathContext);
  const { color } = props;
  const isMobile = useContext(MobileContext);
  const refContruction = useRef(null);
  const [data, setData] = useState([]);
  const [endpoint, setEndpoint] = useState(null);

  let colorsArray = [
    'white',
    'pink',
    'green',
    'green',
    'white',
    'pink',
    'pink',
    'green'
  ];
  let bgArray = [
    'transparent-rhombus-white.svg',
    'transparent-saw-square-white.svg',
    'transparent-rhombus-white.svg',
  ];
  useEffect(() => {
    fetch(`${path}/data/config.json`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {

        if (data.endpoint !== null && data.endpoint !== '') {
          setEndpoint(data.endpoint);
        }
      });
  }, [path]);

  useEffect(() => {
    const wrap = refContruction.current;

    let options = {
      threshold: 0,
      rootMargin: '0% 0% -10% 0%'
    }
    if (isMobile) {
      options = {
        threshold: 0,
        rootMargin: '0% 0% 0% 0%'
      }
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // if (data.length === 0) return;
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.wrap_animate);
          observer.unobserve(entry.target);
        }
      })
    }, options);

    if (wrap !== null) {
      observer.observe(wrap);
    }
    return () => {
      if (wrap !== null) {
        observer.unobserve(wrap);
      }
    }
  }, [isMobile, data]);

  // загрузка несортированного списка
  useEffect(() => {
    if (endpoint === null) return;
    const query = `query {
        hotVacancies {
              name,
              position,
            vacancy {
              id
            }
        }
      }   
    `;
    if (localStorage.getItem('cachedDataInvite') && localStorage.getItem('cacheTimeInvite')) {
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - localStorage.getItem('cacheTimeInvite');
      if (timeDifference < 5 * 60 * 1000) {
        setData(JSON.parse(localStorage.getItem('cachedDataInvite')));
        return;
      }
    }

    fetch(`${endpoint}/graphql`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        let hotVacancies = data.data.hotVacancies;
        hotVacancies.sort((a, b) => a.position - b.position);
        setData(hotVacancies);

        localStorage.setItem('cachedDataInvite', JSON.stringify(hotVacancies));
        localStorage.setItem('cacheTimeInvite', new Date().getTime());
      })
      .catch(error => {
        console.error(error);
      });
  }, [endpoint]);

  switch (color) {
    case 'green_secondary':
      colorsArray = [
        'white',
        'green',
        'blue',
        'blue',
        'white',
        'green',
        'green',
        'blue'
      ];
      break;
    case 'green':
      colorsArray = [
        'white',
        'pink',
        'green_light',
        'green_light',
        'white',
        'pink',
        'pink',
        'green_light'
      ];
      break;
    case 'blue':
      colorsArray = [
        'white',
        'green',
        'white',
        'yellow',
        'white',
        'yellow',
        'yellow',
        'green'
      ];
      break;

    default:
      break;
  }
  if (isMobile) {
    switch (color) {
      case 'green':
        colorsArray = [
          'transparent',
          'pink',
          'transparent',
          'transparent',
          'transparent',
          'transparent',
          'transparent',
          'transparent'
        ];
        bgArray = [
          'transparent-rhombus-white.svg',
          'transparent-circle-white.svg',
          'green-light-rhombus-2.svg',
        ];
        break;

      default:
          colorsArray = [
          'transparent',
          'pink',
          'transparent',
          'transparent',
          'transparent',
          'transparent',
          'transparent',
          'transparent'
        ];
        
        bgArray = [
          'transparent-rhombus-white.svg',
          'transparent-circle-white.svg',
          'green-light-rhombus-2.svg',
        ];
        break;
    }
  }
  return (
    <>
      <div className={styles.wrap} ref={refContruction}>
        <div className={styles.row}>
          <div className={`${styles.construct} ${styles.construct_square}`}>
            <Figure bg={bgArray[0]}>
            </Figure>
          </div>
          <div className={`${styles.construct} ${styles.construct_square}`}>
            <Figure bg={bgArray[1]}>
            </Figure>
          </div>
          <a href={data[0] !== undefined ? `/vacancies/vacancy?vacancy_id=${data[0].vacancy.id}` : null} className={styles.construct}>
            <Figure color={colorsArray[0]}>
              <div className={styles.construct__text}>{data[0] !== undefined ? data[0].name : 'Лаборант'}</div>
            </Figure>
          </a>
        </div>


        <div className={styles.row}>
          <div className={`${styles.construct} ${styles.construct_square}`}>
            <Figure color={colorsArray[1]} form={'circle'}>
            </Figure>
          </div>
          <a href={data[1] !== undefined ? `/vacancies/vacancy?vacancy_id=${data[1].vacancy.id}` : null} className={styles.construct}>
            <Figure color={colorsArray[2]}>
              <div className={styles.construct__text}>{data[1] !== undefined ? data[1].name : 'Инженер-механик'}</div>
            </Figure>
          </a>
          <div className={`${styles.construct} ${styles.construct_square}`}>
            <Figure color={colorsArray[3]} form={'circle'}>
            </Figure>
          </div>
        </div>

        <div className={styles.row}>
          <a href={data[2] !== undefined ? `/vacancies/vacancy?vacancy_id=${data[2].vacancy.id}` : null} className={styles.construct}>
            <Figure color={colorsArray[4]}>
              <div className={styles.construct__text}>{data[2] !== undefined ? data[2].name : 'Медицинский представитель'}</div>
            </Figure>
          </a>
          <a href={data[3] !== undefined ? `/vacancies/vacancy?vacancy_id=${data[3].vacancy.id}` : null} className={styles.construct}>
            <Figure color={colorsArray[5]}>
              <div className={styles.construct__text}>{data[3] !== undefined ? data[3].name : 'Биотехнолог'}</div>
            </Figure>
          </a>
        </div>

        <div className={styles.row}>
          <div className={`${styles.construct} ${styles.construct_square}`}>
            <Figure bg={bgArray[2]}>
            </Figure>
          </div>
          <a href={data[4] !== undefined ? `/vacancies/vacancy?vacancy_id=${data[4].vacancy.id}` : null} className={styles.construct}>
            <Figure color={colorsArray[6]}>
              <div className={styles.construct__text}>{data[4] !== undefined ? data[4].name : 'Бухгалтер'}</div>
            </Figure>
          </a>
          <a href={data[5] !== undefined ? `/vacancies/vacancy?vacancy_id=${data[5].vacancy.id}` : null} className={styles.construct}>
            <Figure color={colorsArray[7]}>
              <div className={styles.construct__text}>{data[5] !== undefined ? data[5].name : 'Оператор '} </div>
            </Figure>
          </a>
        </div>
      </div>
    </>
  );

}

export default Constructions;
